// Meta Pixel client helpers.
// The base pixel + PageView is fired directly from `public/index.html` (loads
// once, on first paint of any route). Here we expose small typed wrappers for
// the standard events we fire from React callbacks after a successful
// submission.

/**
 * Fire a Meta Pixel `Lead` event.
 * Fails silently if the pixel didn't load (ad-blockers, no consent, etc.).
 *
 * @param {Object} [params]
 * @param {string} [params.content_name] - e.g. "Contact form", "Hiring Scan"
 * @param {string} [params.content_category] - e.g. "prenota-call", "hiring-scan"
 * @param {number} [params.value]
 * @param {string} [params.currency]
 */
export function trackLead(params = {}) {
  try {
    if (typeof window !== "undefined" && typeof window.fbq === "function") {
      window.fbq("track", "Lead", params);
    }
  } catch (e) {
    // never break the user flow on pixel failure
  }
}

/**
 * Generic fbq passthrough for custom events (kept for future use).
 */
export function trackEvent(eventName, params = {}) {
  try {
    if (typeof window !== "undefined" && typeof window.fbq === "function") {
      window.fbq("track", eventName, params);
    }
  } catch (e) {
    // no-op
  }
}
